import { showToast } from './components/dialog';
import main from './main';

/// 通用 图片上传
export async function apiUploadPic(file: File) {
  var res = await main.api.post(
    '/resource/oss/upload',
    { file },
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  let url: string | null = null;
  if (res.data.code === 200) {
    url = res.data.data.url;
  } else {
    showToast(res.data.msg);
  }
  return url;
}

/**
 * 获取配置列表
 * @returns
 */
export async function apiGetConfigList() {
  return await main.api.get('/system/config/getConfigList');
}

/**
 * 获取导航广告位
 * @returns
 */
export async function apiGetRouteNav() {
  return await main.api.get('/client/common/getIndex');
}
/**
 * 获取分类
 * @returns
 */
export async function apiGetGoodsCatList() {
  return await main.api.get('/client/goods/getGoodsSort');
}
/**
 * 成为推广者
 * @param id 邀请者ID
 */
export async function apiInviteUser(id: string) {
  var formData = new FormData();
  formData.append('userId', id);
  return await main.api.post('/client/user/addPartner', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
/**
 * 通用 获取手机验证码
 * @param phonenumber
 * @returns
 */
export async function apiGetSmsCode(phonenumber: string) {
  return await main.api.get('/resource/sms/code', {
    params: { phonenumber: phonenumber },
  });
}

/**
 * 手机号登录
 * @param phonenumber
 * @param smsCode
 * @returns
 */
export async function apiLogin(phonenumber: string, smsCode: string, invitationCode?: string) {
  return await main.api.post('/auth/login', {
    phonenumber: phonenumber,
    smsCode: smsCode,
    clientId: main.clientId,
    grantType: 'sms',
    invitationCode,
    tenantId: '000000',
  });
}

/**
 *  获取用户信息
 * @param token
 * @returns
 */
export async function apiGetUserInfo(token: string) {
  main.api.defaults.headers.common['Authorization'] = `Bearer ${main.loginToken || token}`;
  return await main.api.get('/system/userMobile/getUserInfo');
}

/**
 * 获取版本信息
 */
export async function apiGetVersionInfo(type: string) {
  return await main.api.get(`/client/common/getAppVersion/${type}`);
}

/**
 * 获取商品列表
 * @param cat 分类
 * @returns
 */
export async function apiGetGoodsList(cat: string) {
  return await main.api.get(`/client/goods/getGoodsList/${cat}/shop`);
}

/**
 * 获取商品详情
 * @param id 商品ID
 * @returns
 */
export async function apiGetGoodsDetail(id: string) {
  return await main.api.get(`/client/goods/getGoodsInfo/${id}`);
}

/**
 * 下单
 * @param data
 * @returns
 */
export async function apiSubmitOrder(data: any) {
  return await main.api.post('/client/order/submitOrder', data);
}

/**
 * 获取openId
 * @param code
 * @returns
 */
export async function apiCodeToOpenId(code: string) {
  return await main.api.get(`/client/user/getOpenId?code=${code}`);
}

/**
 * 获取协议
 * @returns
 */
export async function apiGetProtocolList() {
  return await main.api.get(`/auth/agreement/${main.clientId}`);
}

/**
 * jsapi配置
 * @param url
 * @param appId
 * @returns
 */
export async function apiGetWeChatSignature(url: string, appId: string) {
  return await main.api.get(`/client/common/getWeChatSignature`, { params: { url: encodeURIComponent(url), appId } });
}
// 获取宽带商品列表
export async function apiGetBroadbandGoodsList() {
  return await main.api.get(`/client/goods/getBroadbandGoodsList`, { params: {} });
}
// 保存宽带订单
export async function apiSaveBandWidthOrder(data: any) {
  return await main.api.post(`/client/goods/saveBandWidthOrder`, data);
}

/**
 * 订单提交-美嘉权益
 * @param data
 * @returns
 */
export async function apiMJiaSubmitOrder(data: any) {
  return await main.api.post('/client/order/mJia/submitOrder', data);
}

// 获取商品运费
export async function apiGetSelFreight(params: any) {
  return await main.api.get(`/client/goodsCarryTemplate/selFreight`, { params });
}
